import React, { Component } from 'react';

export default class Mapping extends Component {

    render () {
        return (
        <div style={{backgroundColor: '#00BFFF' }}>
            <img src="https://mir-s3-cdn-cf.behance.net/project_modules/disp/0efaf032676677.568ed0d61d000.gif" alt="404 Star Wars AT-AT Walker" width="675px" height="585px" style={{borderRadius: '1%'}}/>
        </div>)
    }

}


